import type { ElementType, HTMLAttributes, ReactNode, Ref } from "react"

import { gapScale } from "@/components/ui/layout"
import { tv, type VariantProps } from "@/lib/utils/tv"

const stack = tv({
  base: "flex flex-col",
  variants: {
    gap: gapScale,
    align: { start: "items-start", center: "items-center", end: "items-end", stretch: "items-stretch" },
    divide: { true: "divide-y divide-line-subtle", dashed: "divide-y divide-dashed divide-line-subtle" },
  },
  defaultVariants: { gap: "300", align: "stretch" },
})

interface StackProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof stack> {
  ref?: Ref<HTMLElement>
  as?: ElementType
  children?: ReactNode
}

export const Stack = ({ gap, align, divide, as, className, children, ...rest }: StackProps) => {
  const Element = as ?? "div"
  return (
    <Element className={stack({ gap, align, divide, className })} {...rest}>
      {children}
    </Element>
  )
}
